module.exports = __webpack_public_path__ + "img/colson-whitehead.810b1bc7.png";